import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import store from './store';
import './styles/main.scss';
import {recoverFromChunkError} from './utils/pageLoadResilience.mjs';
window.addEventListener('vite:preloadError',event=>{if(recoverFromChunkError(event.payload))event.preventDefault();});

// PWA: production builds register the offline-shell service worker.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js',{updateViaCache:'none'}).catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
